var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row sc",class:`sc--${_vm.type}`},[_c('div',{staticClass:"p-0",class:{
      'col-12': _vm.isFullWidth,
      'col-6': _vm.isEqualWidth,
      'col-8': !_vm.isEqualWidth,
    }},[_c('div',{staticClass:"sc-label h4"},[_vm._t("label")],2),_c('div',{staticClass:"sc-content"},[_vm._t("content")],2)]),_c('div',{staticClass:"p-0 d-flex justify-contend-end flex-row",class:{ 'col-4': !_vm.isEqualWidth, 'col-6': _vm.isEqualWidth }},[(_vm.hasActionsContentSlot)?_c('div',{staticClass:"actions-content"},[_vm._t("actions-content")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }